@if (!categoryProperties.isEmpty) {
  <div id="{{ categoryProperties.key }}">
    <div class="d-flex justify-content-between align-items-center mb-1_25">
      <div class="font-size-24 font-weight-bold" data-cy-class="title">{{ title }}</div>
      @if (!summary) {
        <div class="report_error d-flex align-items-center hidden_sm">
          <mat-checkbox
            class="mat-checkbox-danger"
            (change)="handleCheckboxError(textareaError)"
            [(ngModel)]="categoryProperties.reportError"
            [attr.data-cy]="'checkboxConfirmTaxReturnReportError_' + categoryProperties.key"
          >
          </mat-checkbox>
          <div class="checkbox_label font-weight-bold font-size-20 ml-0_75">
            {{ "CONFIRM_TAX_RETURN.REPORT_ERROR.CHECKBOX_LABEL" | translate }}
          </div>
        </div>
      }
      @if (summary && categoryProperties.stepUrl) {
        <div class="report_error d-flex align-items-center hidden_sm">
          <app-button-edit [withText]="true" (clickEmitter)="goToStepWorkflow()"></app-button-edit>
        </div>
      }
    </div>
    <ng-container *ngTemplateOutlet="templateRef"></ng-container>
    @if (!summary) {
      <div class="report_error d-flex align-items-center hidden_above_sm mt-n1 mb-2">
        <mat-checkbox
          class="mat-checkbox-danger"
          (change)="handleCheckboxError(textareaError)"
          [(ngModel)]="categoryProperties.reportError"
        >
        </mat-checkbox>
        <div class="checkbox_label font-weight-bold font-size-20 ml-0_75">
          {{ "CONFIRM_TAX_RETURN.REPORT_ERROR.CHECKBOX_LABEL" | translate }}
        </div>
      </div>
    }
    @if (!summary) {
      <div #textareaError class="mb-2 mt-n1" [hidden]="!categoryProperties.reportError">
        <app-form-input
          [textArea]="true"
          [placeholder]="'CONFIRM_TAX_RETURN.REPORT_ERROR.TEXTAREA_PLACEHOLDER'"
          [label]="'CONFIRM_TAX_RETURN.REPORT_ERROR.TEXTAREA_LABEL'"
          [(model)]="categoryProperties.errorMessage"
          [attr.data-cy]="'inputConfirmTaxReturnReportError_' + categoryProperties.key"
        ></app-form-input>
      </div>
    }
    @if (summary && categoryProperties.stepUrl) {
      <div class="report_error d-flex align-items-center hidden_above_sm mt-n1 mb-2">
        <app-button-edit [withText]="true" [isSmallMobile]="true" (clickEmitter)="goToStepWorkflow()"></app-button-edit>
      </div>
    }
  </div>
}
